import React from 'react';
import { NodeCardShell } from './NodeCardShell';
import { NodeCardProps } from './NodeCardProps';

export const GenericNodeCard: React.FC<NodeCardProps> = ({ node, index, onToggle, onEditOpen }) => (
  <NodeCardShell node={node} index={index} onIconClick={onToggle} onEditOpen={onEditOpen} />
);
